import React from 'react';
import styles from './NotForDiagnosticBanner.module.css';

// Always-visible top-of-viewport banner. Renders on every route via App.jsx
// so providers cannot miss the diagnostic-use disclaimer.
//
// Lumen is image management + clinical reference, not a primary diagnostic
// reader. Final reads should happen on FDA-cleared diagnostic displays.
export default function NotForDiagnosticBanner() {
  return (
    <div className={styles.bar} role="alert" aria-live="polite">
      <span className={styles.icon} aria-hidden>⚠</span>
      <span className={styles.text}>
        FOR VIEWING ONLY — NOT FOR PRIMARY DIAGNOSIS
      </span>
      <span className={styles.sub}>
        Image quality is not validated for diagnostic interpretation.
      </span>
    </div>
  );
}
